import { CommonComponents, CommonComponentsFn } from "@me8eon/components";
import { FeatureFlags, flaggedValue } from "@me8eon/featureflags";
import { EonSelectionButton } from "@me8eon/eon_selection_button";
import { SimpleSelectableButton, SimpleSelectableButtonBar } from "@me8eon/selection_button";
import { SimpleClipHeight } from "@me8eon/clip_height";
import { SimpleTable } from "@me8eon/table";
import { SimpleBgMouseOver, SimpleMouseOver } from "@me8eon/mouse_over";
import { SimpleTwoColumnAndRestLayout } from "@me8eon/layouts";
import { SimpleOutsideClick } from "@me8eon/outside_click";
import { SimpleLoadingOrError } from "@me8eon/async";
import { SimpleMonoCline } from "@me8eon/monocline";

export const commonComponentsFn: CommonComponentsFn = (ffs: FeatureFlags): CommonComponents => ({
    BgMouseOver: SimpleBgMouseOver,
    ClipHeight: SimpleClipHeight,
    MouseOver: SimpleMouseOver,
    SelectableButton: SimpleSelectableButton,
    OutsideClick: SimpleOutsideClick,
    SelectableButtonBar: SimpleSelectableButtonBar,
    Table: SimpleTable,
    TwoColumnAndRest: SimpleTwoColumnAndRestLayout,
    LoadingOrError: SimpleLoadingOrError,
    MonoCline: SimpleMonoCline,
});